/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class profileContactDetailsEmailTab extends mixinBehaviors([accessibilityBehaviours.commonFunctions, sbBehaviours.currencyFormatorBehaviour, corpBehaviours.appCommonBehaviour], PolymerElement) {
  static get template() {
    return html`
         
          <style  include="app-styles">  
            div[preferredBackground]{
              background: var(--brand-color);
            } 
            div[preferredLabel]{
              color: var(--primary-light-color);
            } 
            div[preferredEmailId]{
              color: var(--secondary-light-color);
            } 
            paper-icon-button[preferredIcon]{
              color: var(--primary-light-color);
            }
            .ironListNoXScroll{
              overflow-x:hidden;
              overflow-y:hidden;
            }
            .paddingTop4{
              padding-top:4%;
            }
            .EditButtonWidth{
            width: calc(25% - 8px) !important;
            }
         </style>
          <!--AJAX call to fetch details of address -->
         <oe-ajax id="addressEmailFetch" url="/api/CBUsers/{{userId}}/personaldetails" on-response="addressEmailResponse" on-error="adressListError"></oe-ajax>
          <div class="mdl-grid"></div>
            <iron-list class="listing-1 ironListNoXScroll" items="{{emailTypes}}" role="list" id="email-ironlist">
              <template>
              <div class="mdl-grid mdl-cell--12-col padding-t-zero padding-b-zero" >
                <div role="listitem" aria-selected="undefined" aria-readonly="true"  preferredBackground$="{{item.preferredContact}}" id="email_background_{{index}}" class="margin-b-zero mdl-cell border-1px border-round-8px mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col padding-zero">
                  <div class="mdl-grid padding-r-zero">
                    <div class="outlineOffset margin-b-zero margin-l-zero margin-t-zero mdl-cell mdl-cell--3-col-phone mdl-cell--6-col-tablet mdl-cell--9-col" id="focused-div" tabindex=0>
                      <div preferredLabel$="{{item.preferredContact}}" id="email_label_{{index}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col font-size-m">
                        <oe-i18n-msg msgid="{{item.editLabel}}"></oe-i18n-msg>
                      </div>
                      <div preferredEmailId$="{{item.preferredContact}}" id="email_number_{{index}}" class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col secondary-dark-text-s">
                        <template is="dom-if" if="{{item.isContactPresent}}">
                          {{item.emailId}}
                        </template>
                        <template is="dom-if" if="{{!item.isContactPresent}}">
                          <oe-i18n-msg msgid="{{item.label}}"></oe-i18n-msg>
                        </template>
                      </div>
                    </div>
                    <template is="dom-if" if="{{item.isContactPresent}}">
                      <div class="EditButtonWidth margin-r-zero margin-t-zero mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col secondary-dark-text-s text-align-right">
                        <paper-icon-button class="iron-icon-style-m" preferredIcon$="{{item.preferredContact}}" id="email_edit_icon_{{index}}" icon="pencil" on-keydown="setFocus" on-tap="modifyEmail" aria-label$="{{item.editAriaLabel}}"></paper-icon-button>
                      </div>
                    </template>
                    <template is="dom-if" if="{{!item.isContactPresent}}">
                      <div class="paddingTop4 mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col secondary-dark-text-s text-align-right">
                        <div id="email_add_button" on-keydown="setFocus" role="button" on-tap="modifyEmail" class="outlineOffset text-brand-color flat-button cursor-pointer" tabindex="0">
                          <oe-i18n-msg aria-label$="{{item.addAriaLabel}}"  msgid="b_AddWithPlusSign"></oe-i18n-msg>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              </template>
            </iron-list>
            
          `;
  }

  static get properties() {
    return {
      //To store all the email types
      emailTypes: {
        type: Array,
        notify: true,
        value: [{
          "codeType": "PFML",
          "cmCode": "HOMEEML",
          
          "label": "l_personalEmailIDNotFound",
          "editLabel": "l_personalEmailID",
          "pageTitle": "h_addPersonalEmail",
          "cType": "personalEmailId",
          "originalEmail": "",
          "emailId": "",
          "tempFlag": true,
          "updateScenario": false,
          "addAriaLabel": getLabel('m_AddPersonalEmailId'),
          "editAriaLabel": getLabel('m_EditPersonalEmailId')
        }, {
          "codeType": "PFML",
          "cmCode": "WORKEML",
          
          "label": "l_officeEmailIDNotFound",
          "editLabel": "l_OfficeEmailID",
          "pageTitle": "h_addOfficeEmail",
          "cType": "workEmailId",
          "originalEmail": "",
          "emailId": "",
          "tempFlag": true,
          "updateScenario": false,
          "addAriaLabel": getLabel('m_AddOfficialEmailId'),
          "editAriaLabel": getLabel('m_EditOfficialEmailId')
        }]
      },
      //Iron page selector for pages in profile-main
      myprofilepagenumber: {
        type: Number,
        notify: true
      },
      //Iron page selectore for pages in contact details tabs
      selectedEmailDetails: {
        type: Object,
        notify: true
      },
      //To store all the address and contact details
      commDetails: {
        type: Array,
        notify: true
      },
      personalDetails: {
        type: Array,
        notify: true,
        observer: "addressResponse"
      },
      fromEmailEditPage: {
        type: Boolean,
        notify: true,
        observer: "checkBooleanValue"
      },
      personalDetailsResponse: {
        type: Array,
        notify: true
      }

    };
  }

  connectedCallback() {
    super.connectedCallback();
   // this.$$("#addressFetch").generateRequest();
  } //called when communication details are recieved


  addressResponse() {
    this.commDetails = [];
    this.commDetails.push(this.personalDetails);
    if (this.commDetails != undefined && this.commDetails[0].contactDetails != undefined)
      this.getemailTypes();
    this.fire('stop-processing-loader');
  } //This functions creates the list of email types with the details


  getemailTypes() {
    var self = this;
    var contactDetails = [];
    var preferredPhone = "";

    for (let i = 0; i < self.commDetails[0].contactDetails.length; i++) {
      if (self.commDetails[0].contactDetails[i].contactType.codeType == "PFML") {
        contactDetails.push(self.commDetails[0].contactDetails[i]);
      }

      if (self.commDetails[0].contactDetails[i].contactType.codeType == "PFPH") {
        preferredPhone = self.commDetails[0].contactDetails[i].contactType.cmCode;
      }
    }

    for (let i = 0; i < self.emailTypes.length; i++) {
      self.emailTypes[i].preferredPhone = preferredPhone;
      self.emailTypes[i].isContactPresent = false;
      self.emailTypes[i].preferredContact = false;

      for (let j = 0; j < contactDetails.length; j++) {
        if (self.emailTypes[i].cmCode == contactDetails[j].contactType.cmCode) {
          if (contactDetails[j].preferredContact.cmCode == "Y") {
            self.emailTypes[i].alwaysPreferred = true;
            self.emailTypes[i].preferredContact = true;
            self.emailTypes[i].preferredcmCode = contactDetails[j].contactType.cmCode;
          }
          else{
          self.emailTypes[i].alwaysPreferred = false;
            self.emailTypes[i].preferredContact = false;
            self.emailTypes[i].preferredcmCode="";
          }
          self.emailTypes[i].originalEmail = contactDetails[j].emailId;
          self.emailTypes[i].emailId = contactDetails[j].emailId;
          self.emailTypes[i].isContactPresent = true;
          self.emailTypes[i].updateScenario = true;
          if (self.emailTypes[i].cmCode == "HOMEEML") self.emailTypes[i].pageTitle = "h_updatePersonalEmail"; else if (self.emailTypes[i].cmCode == "WORKEML") self.emailTypes[i].pageTitle = "h_updateOfficeEmail";
        }
      }
    }
  }

  //This function navigates to the input page of the selected email
  modifyEmail(event) {
    var data = event.model.item;
    this.selectedEmailDetails = _.cloneDeep(data);
    this.myprofilepagenumber = 11;
  }


  setFocus(event) {
    for (let i = 0; i < this.emailTypes.length; i++) {
      if (event.model.__data.index == this.emailTypes.length - 1) {
        if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
          this.shadowRoot.querySelector("#focused-div").focus();
        }
      }
    }
  }

  checkBooleanValue() {
    if (this.fromEmailEditPage) {
      this.$$("#addressEmailFetch").generateRequest();
      this.fromEmailEditPage = false;
    }
  }

  addressEmailResponse(e) {
    var response = e.detail.response;
    this.personalDetails = response;
    this.personalDetailsResponse = response;
    this._refreshEmailDetails();
  }
  _refreshEmailDetails() {
    var temp = _.cloneDeep(this.emailTypes);
    this.emailTypes = [];
    this.emailTypes = temp;
    var ironList = this.$$("#email-ironlist");
    ironList.__data.items = this.emailTypes;
    if (ironList) {
      ironList._render();
    }

  }

} // Associate the new class with an element name


customElements.define('profile-contact-details-email-tab', profileContactDetailsEmailTab);